// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"44a20a6a","455":"df4d0726","977":"fd810007"}[chunkId] + ".chunk.js";
};